var DialogGroupsModule = /** @class */ (function () {
    function DialogGroupsModule() {
    }
    return DialogGroupsModule;
}());
export { DialogGroupsModule };
